import { render } from "./ClientManager.vue?vue&type=template&id=4f4bcf61&scoped=true"
import script from "./ClientManager.vue?vue&type=script&lang=js"
export * from "./ClientManager.vue?vue&type=script&lang=js"

import "./ClientManager.vue?vue&type=style&index=0&id=4f4bcf61&scoped=true&lang=css"
import "./ClientManager.vue?vue&type=style&index=1&id=4f4bcf61&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f4bcf61"]])

export default __exports__